import { Injectable } from '@angular/core';
import { ScriptInjectorService } from './script-injector.service';

import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import IAnalyticsWindow from '../../interfaces/shared/IAnalyticsWindow';
import { environment } from '../../../../environments/environment';
import { IClickElement } from '../../interfaces/shared/IClickElement';

declare const window: IAnalyticsWindow;
declare global {
  interface Window {
    _satellite: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {

  private satelliteReady = new BehaviorSubject<boolean>(false);
  constructor(private scripInjectorService: ScriptInjectorService) { }

  initAdobeLaunchDataLayer() {
    this.resetDataLayer();
  }

  resetDataLayer() {
    window.digitalData = {
      pageName: '',
      pageContentType: '',
      pageDigitalChannel: '',
      pageSection: '',
      pageLanguage: '',
      CategoryActionLabel: '',
      nivel1: '',
      nivel2: '',
      nivel3: '',
      nivel4: '',
      nivel5: '',
      nivel6: '',
      familySelection: '',
      productName: '',
      productType: '',
      productArea: '',
      productDate: '',
      productCostStart: '',
      productCostUpgrades: '',
      productPack: '',
      productPayment: '',
      productPaymentType: '',
      processStep: '',
      processType: '',
      processName: '',
      processStatus: '',
      processPrice: '',
      userStatus: '',
      userLang: '',
      userBirth: '',
      userResidence: '',
      clientID: '',
      clientPhone: '',
      IDPresupuesto: '',
      IDPoliza: '',
      physicalUrl: '',
    };
  }

  async injectAdobeLaunchScript() {
    try {
      await this.scripInjectorService.load('launch', environment.adobe);
      window._satellite.pageBottom();
      this.waitForSatellite();
    } catch (e) {
      console.error('Error cargando el script de adobe', e);
    }
  }

  setPageName(pageName: string): void {
    window.digitalData.pageName = pageName;
  }

  setPhysicalUrl(physicalUrl: string): void {
    window.digitalData.physicalUrl = physicalUrl;
  }

  setPageContentType(pageContentType: string): void {
    window.digitalData.pageContentType = pageContentType;
  }

  setPageDigitalChannel(pageDigitalChannel: string): void {
    window.digitalData.pageDigitalChannel = pageDigitalChannel;
  }

  setPageSectione(pageSection: string): void {
    window.digitalData.pageSection = pageSection;
  }

  setPageSection(pageSection: string): void {
    window.digitalData.pageSection = pageSection;
  }

  setPageLanguage(pageLanguage: string): void {
    window.digitalData.pageLanguage = pageLanguage;
  }

  setFamilySelection(familySelection: string): void {
    window.digitalData.familySelection = familySelection;
  }

  setCategoryActionLabel(CategoryActionLabel: string): void {
    window.digitalData.CategoryActionLabel = CategoryActionLabel;
  }

  setNivel1(nivel: string): void {
    window.digitalData.nivel1 = nivel;
  }

  setNivel2(nivel: string): void {
    window.digitalData.nivel2 = nivel;
  }

  setNivel3(nivel: string): void {
    window.digitalData.nivel3 = nivel;
  }

  setNivel4(nivel: string): void {
    window.digitalData.nivel4 = nivel;
  }

  setNivel5(nivel: string): void {
    window.digitalData.nivel5 = nivel;
  }

  setNivel6(nivel: string): void {
    window.digitalData.nivel6 = nivel;
  }

  setProductName(productName: string): void {
    window.digitalData.productName = productName;
  }

  setProductType(productType: string): void {
    window.digitalData.productType = productType;
  }

  setProductDate(productDate: string): void {
    window.digitalData.productDate = productDate;
  }

  setProductArea(productArea: string): void {
    window.digitalData.productArea = productArea;
  }

  setProductCostStart(productCostStart: number): void {
    window.digitalData.productCostStart = productCostStart.toString();
  }

  setProductCostUpgrades(productCostUpgrades: number): void {
    window.digitalData.productCostUpgrades = productCostUpgrades.toString();
  }

  setProductPack(productPack: string): void {
    window.digitalData.productPack = productPack;
  }

  setProductPayment(productPayment: string): void {
    window.digitalData.productPayment = productPayment;
  }

  setProductPaymentType(productPaymentType: string): void {
    window.digitalData.productPaymentType = productPaymentType;
  }

  setIDPresupuesto(IDPresupuesto: string): void {
    window.digitalData.IDPresupuesto = IDPresupuesto;
  }

  setIDPoliza(IDPoliza: string): void {
    window.digitalData.IDPoliza = IDPoliza;
  }

  setClientID(clientID: string): void {
    window.digitalData.clientID = clientID;
  }

  setClientPhone(clientPhone: string): void {
    window.digitalData.clientPhone = clientPhone;
  }

  setProcessStep(processStep: string): void {
    window.digitalData.processStep = processStep;
  }

  setProcessType(processType: string): void {
    window.digitalData.processType = processType;
  }

  setProcessName(processName: string): void {
    window.digitalData.processName = processName;
  }

  setProcessStatus(processStatus: string): void {
    window.digitalData.processStatus = processStatus;
  }

  setProcessPrice(processPrice: string): void {
    window.digitalData.processPrice = processPrice;
  }

  setUserStatus(userStatus: string): void {
    window.digitalData.userStatus = userStatus;
  }

  setUserLang(userLang: string): void {
    window.digitalData.userLang = userLang;
  }

  setUserBirth(userBirth: string): void {
    window.digitalData.userBirth = userBirth;
  }

  setUserResidence(userResidence: string): void {
    window.digitalData.userResidence = userResidence;
  }

  trackEvent(nameEvent: any) {
    window._satellite.track(nameEvent);
  }

  startEvents(nameEvent: any) {
    this.executeAnalitycsRequest(() => window._satellite.track(nameEvent));
  }

  startEventsWithCallback(nameEvent: string, callback: Function) {
    this.executeAnalitycsRequest(() => {
      try {
        if (window._satellite && typeof window._satellite.track === 'function') {
          window._satellite.track(nameEvent);
        }
      } catch (e) {
        console.warn('Analytics error:', e);
      }
      setTimeout((_: any) => callback(), 100);
    });
  }

executeAnalitycsRequest(callback: Function) {

  if (
    !window.Cookiebot ||
    !window.Cookiebot.consent ||
    !window.Cookiebot.consent.necessary ||
    !window.Cookiebot.consent.statistics
  ) {
    callback();
    return;
  }

  if (
    !window._satellite ||
    typeof window._satellite.track !== 'function'
  ) {
    callback();
    return;
  }

  callback();
}

startEventWithCallback(eventName: string, callback: Function) {

  this.executeAnalitycsRequest(() => {

    try {
      if (
        window._satellite &&
        typeof window._satellite.track === 'function'
      ) {
        window._satellite.track(eventName);
      }
    } catch (e) {
      console.warn('Analytics error:', e);
    }

    callback();
  });
}

  /**
   *
   * @param payload IClickElement para enviar en v36
   */
  startClickElementEvent(payload: IClickElement) {
    this.executeAnalitycsRequest(() =>
      window._satellite.track('clickElement', payload)
    );
  }

canExecuteAnalytics(): boolean {
  return !!(
    window.Cookiebot &&
    window.Cookiebot.consent &&
    window.Cookiebot.consent.necessary &&
    window.Cookiebot.consent.statistics
  );
}


  waitForSatellite() {
    if (typeof window._satellite.track === 'function') {
      this.satelliteReady.next(true);
      console.log('Adobe Launch esta cargado')
    } else {
      console.warn('Adobe _satellite no está disponible o no se ha inicializado.');
    }
  }

  onReady(): Observable<boolean> {
    return this.satelliteReady.asObservable().pipe(filter(ready => ready));
  }

}
